import { extraLarge, small } from "../../elements/size/index.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import spacer from "../../elements/spacer/spacer.js";
import spinner from "../../elements/spinner/spinner.js";
import text from "../../elements/text/text.js";

/**
 * Render a spinner, a title and a subtitle, vertically aligned.
 *
 * @param {Renderable} title - Some text to show in bold and with a
 *   large font
 * @param {Renderable} subtitle - Some text to show below the title
 *   in a smaller font
 */
export default class ForecastLoadingWidget extends Widget {
	constructor({ title, subtitle }) {
		super(...arguments);

		this._title = title;
		this._subtitle = subtitle;
	}

	renderContentOn(html) {
		html.div(
			{ class: "ForecastLoadingWidget" },
			spacer(
				{ isBlock: true, direction: "vertical", size: extraLarge },
				spinner,
				spacer(
					{ direction: "vertical", size: small },
					text({ emphasize: true, important: true }, this._title),
					text(this._subtitle),
				),
			),
		);
	}
}
